<div class="page-not-found">
  <div>
    <h1>{{ 'page_not_found_error_type' | i18next }}</h1>
    <img
      [src]="this.imageUrlService.getImageUrl('/assets/images/bus.svg')"
      alt="bus image"
    />
    <h2>{{ 'page_not_found_text' | i18next }}</h2>
    <p>{{ 'page_not_found_subtext' | i18next }}</p>
    <div class="btn-wrapper">
      <button (click)="handleReturnHome()">
        {{ 'page_not_found_button_text' | i18next }}
      </button>
    </div>
  </div>
</div>
